import { getTableLinks } from '../table-links/tableLinksCache';
import { LiveClockClient } from './liveClock';

const preferenceKey = (id: number) => `arena:live-clock:${id}`;
export function liveClockPreference(id: number): boolean {
    try { return localStorage.getItem(preferenceKey(id)) === 'true'; } catch { return false; }
}
export function rememberLiveClock(id: number, enabled: boolean): void {
    try { localStorage.setItem(preferenceKey(id), String(enabled)); } catch { /* Session choice still works. */ }
}

export function browserClock(matchId: number, changed: () => void): LiveClockClient {
    return new LiveClockClient(matchId, {
        monotonicNow: () => performance.now(), wallNow: () => Date.now(), random: Math.random,
        links: async () => {
            // Dev-only, localhost-only feed bypasses link issuance; never stores real tokens.
            if (localFeed()) return { scoreboardUrl: 'http://localhost/?token=LOCAL_TEST_ONLY', validUntil: Date.now() + 3600000 };
            const links = await getTableLinks(matchId);
            if (links.status !== 'ok' || !links.scoreboard?.url) throw new Error('Access unavailable');
            return { scoreboardUrl: links.scoreboard.url, validUntil: Date.parse(links.validUntil || '') };
        },
        socket: url => new WebSocket(localFeed() || url),
    }, changed);
}

function localFeed(): string | undefined {
    if (process.env.NODE_ENV !== 'development') return undefined;
    const value = process.env.REACT_APP_LIVE_CLOCK_LOCAL_WS;
    if (!value) return undefined;
    try {
        const url = new URL(value);
        return url.protocol === 'ws:' && ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname)
            ? url.toString() : undefined;
    } catch { return undefined; }
}
